module.exports = __webpack_public_path__ + "img/animate.74ecd365.gif";